<div class="info-toast-bar">
    <p>Before accessing the application, please configure your system preferences. These settings will determine your default view upon login.</p>
</div>

<form [formGroup]="preferencesGroup">
    <!-- Aggregation Level -->
    <div>
        <h2 class="section-header">Default Aggregation Level</h2>
        <mat-form-field appearance="outline">
            <mat-select formControlName="aggregationLevel">
                @for (level of aggregationLevels; track level.name) {
                <mat-option [value]="level">
                    {{ level | aggregationLevel }}
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
    <div>
        <h2 class="section-header">Default States</h2>
        <vulcan-location-filter
            [showAggregationLevels]="false"
            [showCounties]="false"
            [autoSelectCodes]="defaultStateCodes"
            (dataChange)="updateSelectedLocation($event)">
        </vulcan-location-filter>
    </div>
    <div>
        <h2 class="section-header">Legend Options</h2>
        <div class="legend-options">
            <mat-form-field appearance="outline">
                <mat-label>Legend Colors</mat-label>
                <mat-select formControlName="legendStyle" [compareWith]="styleCompare">
                    @for (style of legendStyles(); track style.id) {
                    <mat-option [value]="style">
                        {{ style.name | legendName }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Legend Metric</mat-label>
                <mat-select formControlName="legendMetric">
                    @for (metric of legendMetrics; track metric) {
                    <mat-option [value]="metric">
                        {{ metric | legendMetric }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    </div>
</form>

<div>
    <p class="section-header">Example Legend</p>
    <eaglei-nom-legend
        [allowOverrideToggle]="false"
        [legendMetric]="preferencesGroup.controls.legendMetric.value"
        [legendStyle]="preferencesGroup.controls.legendStyle.value">
    </eaglei-nom-legend>
</div>

<button mat-flat-button color="primary" (click)="savePreferences()">Save</button>
